import * as CONST from '../constants/index';
import { FetchCaseBrandModel, CaseStudyBrandModel, isFilterDataListModel} from '../models/case_study'


const initialState:FetchCaseBrandModel = {
  pending: false,
  case_study: [],
  type_filter_list: [],
  is_filter_list: [],
  error: ""
};

let list_selected : object[] = [];

function editKeyName ( case_studies: any) {
  return case_studies.map( (item: CaseStudyBrandModel) => changeItemNameKey( item ) );
}

function changeItemNameKey ( item: any ) {
  for (let [key, value] of Object.entries(item)){
    item[`${key.toLowerCase().replace(/\s/g, '_')}`] = item[key];
    // value = item[key].replace(/\//g, '/') as string;
    delete item[key];
  }
  // console.log(item, "change item name ======")
  return item;
}

function getTypeFilterDataList(data: CaseStudyBrandModel[]){
  const nameFilterList = ['country', 'industry', 'campaign_objective'];
  let result : any[] = [];
  let subtitle : any[] = [];

  nameFilterList.forEach((item: string) => {
    subtitle = []
    data.forEach((obj:any) => {
      if(!subtitle.includes(obj[item]) && obj[item] !== undefined)
        subtitle.push(obj[item]);
    })
    result.push({'title' : item, 'subtitle': subtitle});
  })
  return result;
}

function countDuplicatByName(list_selected: any) {
  let counter:any = {};

  list_selected.forEach((obj: any) => {
    var key = JSON.stringify(obj) as string;
    counter[key] = (counter[key] || 0) + 1;
    if(counter[key] === 2)
      delete counter[key];

  })

  // console.log(counter,"counter Duplicate")
  return counter;
  
}

function isFilterDataList(data: isFilterDataListModel){
  let result_list_selected : any[] = [];
  const {title, name} = data.type_title;
 
  if(title === null || name === null || title === undefined || name === undefined){
    list_selected = [];
    return [];
  }
  
  const {cs_full_list} = data.data;

  list_selected.push({title, name})  
  var listFiltered = countDuplicatByName(list_selected)
  
  result_list_selected = cs_full_list.filter((item: any,)=>{
    for (const [key] of Object.entries(listFiltered)) {
      var title = key.slice(key.indexOf('"title":"') + 9, key.indexOf('","') );
      var name = key.slice(key.indexOf('name":"') + 7 , key.length - 2);

      // console.log(JSON.stringify(name) === JSON.stringify(hi),JSON.stringify(name), JSON.stringify(hi))
      if(JSON.stringify(name) === JSON.stringify(item[title]))
        return true;
    }

    return false;
  })

  // console.log(result_list_selected, "result_list_selected ======")
  return result_list_selected;  
}

export const rootReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case CONST.FETCH_DATA_API:
      return {
        ...state,
        pending: true
      }

    case CONST.FETCH_DATA_API_SUCCESS:
      return {
        ...state,
        case_study: editKeyName(action.payload),
        pending: false
      }
    
    case CONST.FETCH_DATA_LOCAL:
      return {
        ...state,
        case_study: editKeyName(action.payload),
        pending: false
      }
  
    case CONST.FETCH_DATA_API_ERROR:
      return {
        ...state,
        case_study: action.error,
        pending: false
      }

    case CONST.GET_FILTER_DATA:
      return {
        ...state,
        type_filter_list:  getTypeFilterDataList(action.payload),
      }

    case CONST.FILTER_THE_DATA:
      return {
        ...state,
        is_filter_list:  isFilterDataList(action.payload),
      }

    default: 
      return state;
  }
};